/**
 * Dulce Comienzo — Sticky Add to Cart Bar
 * Archivo: assets/dc-sticky-bar.js
 *
 * Comportamiento:
 * - Aparece cuando el botón original "Agregar al carrito" sale del viewport
 * - Desaparece cuando vuelve a ser visible
 * - Sincroniza la variante seleccionada con el selector principal de la página
 * - Hace el add-to-cart via fetch (AJAX) sin recargar la página
 * - Muestra feedback visual al agregar
 */

(function () {
  'use strict';

  const BAR_ID       = 'dc-sticky-bar';
  const BTN_ID       = 'dc-sticky-atc-btn';
  const SELECT_ID    = 'dc-sticky-variant-select';
  const VISIBLE_CLS  = 'dc-sticky-bar--visible';
  const HIDDEN_CLS   = 'dc-sticky-bar--hidden';
  const ADDED_CLS    = 'dc-sticky-bar__btn--added';

  // El botón original de la página de producto en Dawn usa este selector
  const ORIGINAL_BTN_SELECTOR = '[data-type="add-to-cart-form"] button[type="submit"], form[action="/cart/add"] button[type="submit"]';
  // Selector del select de variante principal de Dawn
  const ORIGINAL_SELECT_SELECTOR = '.product-form__input select, .product-variant-picker select, variant-selects select, variant-radios';

  let stickyBar, stickyBtn, stickyVariantSelect;
  let currentVariantId = null;
  let isAdding = false;

  // ── Init ──────────────────────────────────────────────────
  function init() {
    stickyBar           = document.getElementById(BAR_ID);
    stickyBtn           = document.getElementById(BTN_ID);
    stickyVariantSelect = document.getElementById(SELECT_ID);

    if (!stickyBar || !stickyBtn) return;

    setupScrollObserver();
    setupVariantSync();
    setupAddToCart();

    setTimeout(function () {
      const initialVariantId = getSelectedVariantId();
      if (initialVariantId) {
        currentVariantId = initialVariantId;
        if (stickyVariantSelect) {
          stickyVariantSelect.value = initialVariantId;
        }
      }
    }, 800);
  }

  // ── Observar cuándo el botón original sale del viewport ──
  function setupScrollObserver() {
    const originalBtn = document.querySelector(ORIGINAL_BTN_SELECTOR);
    if (!originalBtn) {
      // Fallback: mostrar siempre si no encontramos el botón original
      showBar();
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hideBar();
          } else {
            showBar();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(originalBtn);
  }

  function showBar() {
    stickyBar.classList.remove(HIDDEN_CLS);
    stickyBar.classList.add(VISIBLE_CLS);
    stickyBar.setAttribute('aria-hidden', 'false');
    document.documentElement.style.setProperty('--dc-sticky-offset', stickyBar.offsetHeight + 'px');
  }

  function hideBar() {
    stickyBar.classList.remove(VISIBLE_CLS);
    stickyBar.classList.add(HIDDEN_CLS);
    stickyBar.setAttribute('aria-hidden', 'true');
    document.documentElement.style.setProperty('--dc-sticky-offset', '0px');
  }

  // ── Sincronizar variante ──────────────────────────────────
  function getSelectedVariantId() {
  // Estrategia 1: URL params (más confiable — Shopify siempre actualiza ?variant=)
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariant = urlParams.get('variant');
  if (urlVariant) return urlVariant;

  // Estrategia 2: input hidden name="id" en el form del producto
  const hiddenInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
  if (hiddenInput && hiddenInput.value) return hiddenInput.value;

  // Estrategia 3: radio button marcado
  const checkedRadio = document.querySelector('input[type="radio"][name="id"]:checked, fieldset input[type="radio"]:checked');
  if (checkedRadio) return checkedRadio.value;

  // Estrategia 4: select principal
  const sel = document.querySelector('select[name="id"], .product-form__input select');
  if (sel && sel.value) return sel.value;

  return null;
}

  function setupVariantSync() {
    if (stickyVariantSelect) {
      stickyVariantSelect.addEventListener('change', function () {
        currentVariantId = stickyVariantSelect.value;
      });
      stickyVariantSelect.style.pointerEvents = 'none';
      stickyVariantSelect.style.cursor = 'default';
      stickyVariantSelect.style.appearance = 'none';
      stickyVariantSelect.style.webkitAppearance = 'none';
      stickyVariantSelect.style.backgroundImage = 'none';
    }

    document.addEventListener('change', function (e) {
      const el = e.target;
      if (
        el.matches('.swatch-input__input') ||
        el.matches('input[name="id"]') ||
        el.closest('variant-selects') ||
        el.closest('variant-radios')
      ) {
        const newId = getSelectedVariantId();
        if (newId && newId !== currentVariantId) {
          currentVariantId = newId;
          if (stickyVariantSelect) {
            stickyVariantSelect.value = currentVariantId;
          }
        }
      }
    });

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        currentVariantId = String(e.detail.variant.id);
        if (stickyVariantSelect) {
          stickyVariantSelect.value = currentVariantId;
        }
        updateButtonAvailability(e.detail.variant.available);
      }
    });
  }

  function syncToMainSelect(variantId) {
    // Dawn embebe los datos de variantes en el JSON del producto
    // Buscar la variante por ID para obtener su título
    let variantTitle = null;
    
    try {
      const productJson = document.getElementById('product-json') ||
        document.querySelector('script[type="application/json"][data-product-id]');
      
      if (productJson) {
        const data = JSON.parse(productJson.textContent);
        const variant = data.variants && data.variants.find(v => String(v.id) === String(variantId));
        if (variant) variantTitle = variant.option1;
      }
    } catch(e) {}

    if (!variantTitle) {
      // Fallback: leer del JSON embebido en variant-selects
      try {
        const variantScript = document.querySelector(
          'variant-selects script[type="application/json"]'
        );
        if (variantScript) {
          const data = JSON.parse(variantScript.textContent);
          if (data && String(data.id) === String(variantId)) {
            variantTitle = data.option1;
          }
        }
      } catch(e) {}
    }

    if (!variantTitle) return;

    // Buscar el radio que tiene ese valor y hacer click en su label
    const targetRadio = document.querySelector(
      '.swatch-input__input[value="' + variantTitle + '"], ' +
      '.product-form__input input[type="radio"][value="' + variantTitle + '"]'
    );
    
    if (targetRadio && !targetRadio.checked) {
      const label = document.querySelector('label[for="' + targetRadio.id + '"]');
      if (label) {
        label.click();
      } else {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function updateButtonAvailability(available) {
    if (!stickyBtn) return;
    stickyBtn.disabled = !available;
    const span = stickyBtn.querySelector('span');
    if (span) {
      span.textContent = available ? 'Agregar al carrito' : 'Agotado';
    }
  }

  // ── Add to Cart (AJAX) ────────────────────────────────────
  function setupAddToCart() {
    stickyBtn.addEventListener('click', async function () {
      if (isAdding || stickyBtn.disabled) return;

      const variantId = currentVariantId || getSelectedVariantId();
      if (!variantId) return;

      isAdding = true;
      const originalSpan = stickyBtn.querySelector('span');
      const originalText = originalSpan ? originalSpan.textContent : 'Agregar al carrito';

      // Estado de carga
      stickyBtn.disabled = true;
      if (originalSpan) originalSpan.textContent = 'Agregando...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: parseInt(variantId),
            quantity: 1,
          }),
        });

        if (!response.ok) throw new Error('Cart add failed');

        // Éxito
        stickyBtn.classList.add(ADDED_CLS);
        if (originalSpan) originalSpan.textContent = '✓ Agregado';

        // Actualizar el contador del carrito en el header de Dawn
        refreshCartCount();

        // Emitir evento nativo de Shopify para que el drawer del carrito se abra (si está configurado)
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(function () {
          stickyBtn.classList.remove(ADDED_CLS);
          stickyBtn.disabled = false;
          if (originalSpan) originalSpan.textContent = originalText;
          isAdding = false;
        }, 2000);

      } catch (err) {
        console.error('[DC Sticky Bar] Error al agregar al carrito:', err);
        stickyBtn.disabled = false;
        if (originalSpan) originalSpan.textContent = originalText;
        isAdding = false;
      }
    });
  }

  // Actualiza el badge de cantidad en el ícono del carrito del header
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count-bubble');
      countEls.forEach(function (el) {
        if (el.tagName === 'SPAN') el.textContent = cart.item_count;
        else el.setAttribute('data-count', cart.item_count);
      });
    } catch (_) {}
  }

  // ── Arrancar cuando el DOM esté listo ─────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();